export const SIDEBAR = "SIDEBAR";
export const PAYMENT_DOCUMENT = "PAYMENT_DOCUMENT";
export const NOTIFICATIONS_COUNT = "NOTIFICATIONS_COUNT";
